import request from './request'

export function getVipMission(query) {
    return request({
        url: '/huhushare/Fissionvip/getVipMission',
        method: 'post',
        data: query
    });
}

export function getVipAward(query) {
    return request({
        url: '/huhushare/Fissionvip/getVipAward',
        method: 'post',
        data: query
    });
}

//获取vip列表
export function getVipList(query) {
    return request({
        url: '/huhuapi/vip/vipList',
        method: 'post',
        data: query
    });
}

//vip下单
export function placyAnVipOrder(query) {
    return request({
        url: '/huhuapi/vip/confirmPay',
        method: 'post',
        data: query
    });
}

//获取vip支付参数
export function VipJsPayByWx(query) {
    return request({
        url: '/huhushare/quickpayment/WxJsPay',
        method: 'post',
        data: query
    });
}

// 查询订单
export function checkPaySuccess(query) {
    return request({
        url: 'huhuapi/vip/checkPaySuccess',
        method: 'post',
        data: query
    });
}

// 查询订单
export function checkPaySuccess1(query) {
    return request({
        url: 'huhuapi/order/checkPaySuccess',
        method: 'post',
        data: query
    });
}

// 查询订单-支付结果
export function checkPayResult(query) {
    return request({
        url: 'huhuapi/vip/checkPayResult',
        method: 'post',
        data: query
    });
}

// 意见建议
export function fankui(query) {
    return request({
        url: 'huhuapi/helper/setFeedback.html',
        method: 'post',
        data: query
    });
}

// 
export function cancelOrder(query) {
    return request({
        url: 'huhuapi/vip/cancelOrder',
        method: 'post',
        data: query
    });
}




// WEBPACK FOOTER //
// ./src/api/vip.js